import { SubmitButtonProps, getSubmitButtonOptions } from "@rjsf/utils";
import { useFormSchema } from "src/api/hooks/useFormSchema";

/**
 * Custom ButtonTemplate to style the submit button to match the app's design
 */
export const CustomButtonTemplate = (props: SubmitButtonProps) => {
  const { data: schema } = useFormSchema();
  const { uiSchema } = props;
  const { norender, submitText } = getSubmitButtonOptions(uiSchema);
  const primaryColor = schema?.theme?.colors?.primary || "#4CAF50";

  if (norender) {
    return null;
  }

  return (
    <div className="flex justify-center mt-6">
      <button
        type="submit"
        className="p-2 border-Grey4 border-2 rounded-xl bg-PrimaryGreen text-White font-medium transition-all duration-200 hover:bg-opacity-90 hover:shadow-lg hover:scale-105 active:scale-100 disabled:bg-Grey4 disabled:border-Grey7 disabled:cursor-not-allowed disabled:text-Grey9 disabled:hover:scale-100 disabled:hover:shadow-none min-w-[120px]"
        style={{
          backgroundColor: primaryColor,
        }}
      >
        {submitText || lang.save}
      </button>
    </div>
  );
};
